import { Booking } from '@interfaces/booking.interface';

type BookingPriceFields = Pick<
  Booking,
  | 'holidayPrice'
  | 'roomsPrice'
  | 'optionsPrice'
  | 'ensurancesPrice'
  | 'couponsTotalValue'
  | 'totalPrice'
  | 'priceChanges'
>;

export function getBookingTotal(booking: BookingPriceFields): number {
  const base =
    booking.holidayPrice !== null
      ? (booking.holidayPrice ?? 0) +
        (booking.roomsPrice ?? 0) +
        (booking.optionsPrice ?? 0) +
        (booking.ensurancesPrice ?? 0) -
        (booking.couponsTotalValue ?? 0)
      : (booking.totalPrice ?? 0);

  return (
    base + (booking.priceChanges ?? []).reduce((acc, pc) => acc + pc.price, 0)
  );
}

export function isFreeBooking(totalPrice: number): boolean {
  return totalPrice === 0;
}

export function isPaymentSatisfied(
  totalPrice: number,
  totalPaid: number,
): boolean {
  return totalPrice === 0 || totalPaid >= totalPrice;
}

export const areParticipantsIncomplete = (booking: Booking) => {
  if (booking.bookingStatus === 'canceled') return false;

  if (booking.partecipants && booking.partecipants.length === 0) {
    return true;
  }

  return booking.partecipants.some(
    (partecipant) =>
      !partecipant.height ||
      !partecipant.birthDate ||
      !partecipant.birthCity ||
      !partecipant.country ||
      !partecipant.phone ||
      !partecipant.email ||
      (partecipant.country === 'Italia' &&
        (!partecipant.province ||
          !partecipant.city ||
          !partecipant.zip ||
          !partecipant.address ||
          !partecipant.taxCode)),
  );
};
